export default "<div class=\"accordion accordion--react\" data-module=\"reactAccordion\"> </div>"